import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w-full text-center py-8 text-gray-500"
}

import { DoctorGroupedResponse } from '@/Network/Types/Responses/CompanyResponses'
import { Card } from '../atoms'
import CardSkeleton from '../atoms/CardSkeleton.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'OutstandingDoctors',
  props: {
    companyDoctors: {},
    isLoading: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createBlock(_component_v_row, null, {
    default: _withCtx(() => [
      (_ctx.isLoading)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, _renderList(8, (n) => {
            return _createVNode(_component_v_col, {
              cols: "12",
              sm: "6",
              md: "6",
              lg: "3",
              xl: "3",
              key: `skeleton-${n}`
            }, {
              default: _withCtx(() => [
                _createVNode(CardSkeleton)
              ]),
              _: 2
            }, 1024)
          }), 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.companyDoctors, (companyDoctor, index) => {
              return (_openBlock(), _createBlock(_component_v_col, {
                cols: "12",
                sm: "6",
                md: "6",
                lg: "3",
                xl: "3",
                key: companyDoctor.doctor.id || index
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Card), { doctor: companyDoctor }, null, 8, ["doctor"])
                ]),
                _: 2
              }, 1024))
            }), 128)),
            (_ctx.companyDoctors.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, " Nenhum médico pendente encontrado. "))
              : _createCommentVNode("", true)
          ], 64))
    ]),
    _: 1
  }))
}
}

})